import { pipe } from 'fp-ts/lib/function';
import {
  chain,
  fromNullable,
  fromPredicate,
  map,
  match,
} from 'fp-ts/lib/Option';

export const hasError = (
  error: string | string[] | undefined
): error is string | string[] =>
  pipe(
    error,
    fromNullable,
    map((err) => (Array.isArray(err) ? err : [err])),
    chain(fromPredicate((x) => x.length > 0)),
    match(
      () => false,
      () => true
    )
  );
